/* eslint-disable */
export default {
  noActiveCalls: 'Nessuna chiamata attiva',
  noCalls: 'Nessun risultato trovato.',
  currentCall: 'Chiamata corrente',
  ringCall: 'Chiamata in arrivo',
  onHoldCall: 'Chiamata in attesa',
  historyCalls: 'Chiamate passate',
  otherDeviceCall: 'Chiamate in corso sugli altri dispositivi',
  searchPlaceholder: 'Ricerca...',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No results found."@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"historyCalls"@#@ @source: @#@"Past Calls"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
